import React, { useState } from 'react';
import { FaTimes } from 'react-icons/fa';
import { useServices } from '../../hooks/useServices';
import '../../styles/DeleteServiceModal.css';

const DeleteServiceModal = ({ service, onClose, onSuccess }) => {
  const { deleteService } = useServices();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleDelete = async () => {
    try {
      setLoading(true);
      setError('');

      await deleteService(service.id);
      onSuccess();
    } catch (error) {
      console.error('Erreur lors de la suppression:', error);
      setError('Erreur lors de la suppression du service');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content delete-service-modal">
        <div className="modal-header">
          <h2>Suppression de service</h2>
          <FaTimes className="close-icon" onClick={onClose} />
        </div>

        <div className="modal-body">
          <div className="warning-content">
            <h3>Attention ! Cette action sera irréversible.</h3>
            <p>
              La suppression de service entraînera. Êtes-vous sûr
              de vouloir supprimer le ou les services ?
            </p>
          </div>

          {error && <div className="error-message">{error}</div>}
        </div>

        <div className="modal-footer">
          <button className="btn-secondary" onClick={onClose}>
            Annuler
          </button>
          <button 
            className="btn-danger" 
            onClick={handleDelete}
            disabled={loading}
          >
            {loading ? 'Suppression...' : 'Supprimer'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteServiceModal;